import { COURSES } from "utils/constants";
import { createExporter } from "utils/createExporter";

export const CoursesExporter = createExporter(`${COURSES}.xlsx`,
    [
        { key: "nameBg", label: "име на български език" },
        { key: "nameEn", label: "име на английски език" },
        { key: "isActive", label: "активен курс" },
    ],
    (record) => ({
        ...record,
        isActive: record.isActive ? "Да" : "Не"
    }),
);